




























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { downloadPDF, formatNumber } from '@/utils/helpers';
import '../style.scss';
import constants from '@/utils/constants';

@Component({
  filters: {
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    },
    formatDate(val: any) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    }
  }
})
export default class HomeDeliveryPDF extends Vue {
  @Prop() item!: any;
  @Prop() isDeskTop!: boolean;
  data: any = {};
  constants: any = constants;
  get includeAllMenu() {
    return this.$store.getters.GetIncludeAllMenu;
  }

  @Watch('item')
  watchItemChange() {
    this.formatData();
  }

  mounted() {
    this.formatData();
  }

  formatData() {
    if (this.item.billing_calculation) {
      this.data = {
        outletName: this.item.raw_data.destinationStore.storeName,
        cityName: this.item.raw_data.destinationStore.storeCityName,
        orderType: this.item.raw_data.orderType,
        orderId: this.item.raw_data.billingNo,
        createdAt: this.item.raw_data.createdDate,
        contact: this.item.raw_data.contact,
        address: this.item.raw_data.deliveryAddress,
        notes: this.item.raw_data.notes,
        orderDetails: this.item.billing_menu_items,
        paymentDetails: this.item.billing_calculation,
        paymentMethod: this.item.payment_method
      };
    } else {
      this.data = this.item;
    }
  }

  download(orderType, orderID) {
    let fileName = '';
    if (orderType === constants.HMD) {
      fileName = `Qraved-Home-Delivery-Order-${orderID}`;
    } else if (orderType === constants.PPTA) {
      fileName = `Qraved-Takeaway-Order-${orderID}`;
    } else if (orderType === constants.PPDI) {
      fileName = `Qraved-Dine-in-Order-${orderID}`;
    } else if (orderType === constants.TOP) {
      fileName = `Qraved-Table-Order-${orderID}`;
    }
    downloadPDF(document.querySelector('.pdf_html'), fileName);
  }
}
